import React from "react";
import { Box, FormLabel } from "@mui/material";

const RequiredLabel = ({ show = true }) => {
  if (!show) return null;

  return (
    <Box sx={{ display: "inline-block", mt: -0.75 }}>
      <FormLabel
        sx={{
          backgroundColor: "red",
          color: "white",
          padding: "2px 8px",
          borderRadius: "4px",
          display: "inline-block",
          minWidth: "fit-content",
          fontWeight: "bold",
          fontSize: "0.75rem",
        }}
      >
        必須
      </FormLabel>
    </Box>
  );
};

export default RequiredLabel;
